const PREFERRED_CAMERA_DEVICE_KEY = 'drawclub.preferredCameraDeviceId';
const PREFERRED_MICROPHONE_DEVICE_KEY = 'drawclub.preferredMicrophoneDeviceId';

export function getPreferredCameraDeviceId() {
  try {
    return window.localStorage.getItem(PREFERRED_CAMERA_DEVICE_KEY) || null;
  } catch {
    return null;
  }
}

export function setPreferredCameraDeviceId(deviceId: string) {
  try {
    if (deviceId) {
      window.localStorage.setItem(PREFERRED_CAMERA_DEVICE_KEY, deviceId);
    }
  } catch {
    // Camera preference is a convenience; switching should still work without storage.
  }
}

export function getPreferredMicrophoneDeviceId() {
  try {
    return window.localStorage.getItem(PREFERRED_MICROPHONE_DEVICE_KEY) || null;
  } catch {
    return null;
  }
}

export function setPreferredMicrophoneDeviceId(deviceId: string) {
  try {
    if (deviceId) {
      window.localStorage.setItem(PREFERRED_MICROPHONE_DEVICE_KEY, deviceId);
    }
  } catch {
    // Microphone preference is a convenience; switching should still work without storage.
  }
}
